<template>
	<div class="main-load">
		<transition name="slide-fade">
			<img src="/hp-banner.jpg" class="logo"/>
		</transition>
		<transition name="fade">
			<div class="loading">
				<Spinner size="big" message="Please wait."></Spinner>
			</div>
		</transition>
	</div>
</template>

<script>
import Spinner from 'vue-simple-spinner'
import AuthService from "@/services/AuthService";
import { mapState } from 'vuex'

export default {
	name: "Logout",
	components: {
		Spinner
	},
    mounted() {
        if (this.gapiLoaded) {
			this.logout()
		}
	},
	computed: {
        ...mapState(['gapiLoaded'])
    },
    watch: {
        gapiLoaded: {
            immediate: true,
            handler(loaded) {
                if (loaded) this.logout();
            }
        }
	},
	methods: {
		async logout() {
			await new Promise(resolve => setTimeout(resolve, 2500)); //wait for auth2 to fully signout
			const gapi = window.gapi;

			gapi.auth2.init({
				client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
			}).then(function(){
				var auth2 = gapi.auth2.getAuthInstance();
				if(auth2.isSignedIn.get()) {
					AuthService.signOutGoogle();
				}
				auth2.disconnect();
			});

			async() => {
				await AuthService.logout();
			}

			AuthService.flushTokens();

			this.$router.push({ path: 'Login' });
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.main-load {
		margin: 0;
		position: absolute;
		top: 45%;
		-ms-transform: translateY(-50%);
		transform: translateY(-50%);
		width: 100%;
	}

	.logo {
		max-width: 600px;
	}

	/* Enter and leave animations can use different */
	/* durations and timing functions.              */
	.slide-fade-enter-active {
		transition: all .8s ease;
	}
	.slide-fade-leave-active {
		transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}
	.slide-fade-enter, .slide-fade-leave-to
		/* .slide-fade-leave-active below version 2.1.8 */ {
		transform: translateY(50px);
		opacity: 0;
	}

	.fade-enter-active, .fade-leave-active {
		transition: opacity .8s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
</style>
